// extracted by mini-css-extract-plugin
export default {"container":"WBPAx8SE","grid":"VigsnOAc"};